import { render, staticRenderFns } from "./ListOrderSales.vue?vue&type=template&id=15f0be34&scoped=true"
import script from "./ListOrderSales.vue?vue&type=script&lang=js"
export * from "./ListOrderSales.vue?vue&type=script&lang=js"
import style0 from "./ListOrderSales.vue?vue&type=style&index=0&id=15f0be34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0be34",
  null
  
)

export default component.exports